// extracted by mini-css-extract-plugin
export default {"pageNotAuthorized":"AuthorizedPermission_pageNotAuthorized__FBF3M","description":"AuthorizedPermission_description__yJyCM"};